'use strict';
var sweepSortAnalyzer = require("../../mobileCore/main/analyzer/sweepSortAnalyzer");
var conversionUtils = require("../../mobileCore/main/conversionUtils");
function splitToFragments(siblings, axis) {
    var sweepLineEvents = sweepSortAnalyzer.createEventsQueue(siblings, axis);
    return sweepSortAnalyzer.createFragments(sweepLineEvents);
}
var mobileLayoutUtils = {
    translateComponents: conversionUtils.translateComps,
    getSnugLayout: conversionUtils.getSnugLayout,
    splitToFragments: splitToFragments
};
module.exports = mobileLayoutUtils;



//////////////////
// WEBPACK FOOTER
// ./src/mobileLayoutUtils/main/mobileLayoutUtilsPublicAPI.ts
// module id = 31
// module chunks = 1